import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { Select } from 'antd';
import { DevicesTabContext, IDevicesTabContext } from '../../../devicesTabState/devicesTabContext';
import style from './CountOfItem.module.scss';

const { Option } = Select;

const CountOfItem: React.FC = () => {
	const { setDevicesTabCountOfItems, devicesTabCountOfItems } = useContext<IDevicesTabContext>(DevicesTabContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="showLabel" size="s" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setDevicesTabCountOfItems}
				value={devicesTabCountOfItems}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}>
				<Option className={style.listItem} value="12">
					12
				</Option>
				<Option className={style.listItem} value="24">
					24
				</Option>
				<Option className={style.listItem} value="48">
					48
				</Option>
			</Select>
			<Text translationNameSpace="form" translationKey="entriesLabel" size="s" />
		</div>
	);
};

export default CountOfItem;
